<!-- <div class="container mx-auto">
  <section class="pb-5">
    <div class="banner">
      <div class="relative mt-3">
          <div class="video-wrapper">
            <iframe class="w-full " width="560" height="315" src="https://www.youtube.com/embed/DNbWAopZ4ns?si=8YHeMoSfX1KI5UjK"
              frameborder="0" allowfullscreen></iframe>
          </div>
      </div>
    </div>
  </section>
</div> -->
<div class="px-2">
  <div class="container mx-auto">
    <div class="flex flex-row justify-between pt-14">
      <div class="w-full age-wrap flex flex-row flex-wrap">
        <div class="w-full lg:w-1/2 justify-end mb-12 flex px-8">
          <!-- <img class="h-auto max-h-full" src="assets/images/transcend24/transcend-banner.png"> -->
          <iframe class="w-full " width="560" height="600" src="//www.youtube.com/embed/Un9m87gOeaI?si=XpbIWJdft5KlCrOm"
                      frameborder="0" allowfullscreen></iframe>
        </div>
        <div class="w-full lg:w-1/2 p-4 pt-0">
          <h2 class="text-4xl hidden font-semibold border-[#87c042] border-5 border-l-4 border-solid pl-4 mb-4 text-gray-500 uppercase"><span class="text-[#212457]">Evolve </span> India 2024</h2>
          <h3 class="text-2xl font-semibold  mb-2" [ngClass]="currentTheme === 'dark' ? 'text-gray-300' : 'text-gray-700 '">
            Evolve India 2023
          </h3>
          <span class="text-base font-normal block italic  mb-6" [ngClass]="currentTheme === 'dark' ? 'text-gray-400' : 'text-gray-500'">
            4.00 PM, Wed, 22th Feb 2024
          </span>
          <p class="text-lg mt-4">Looking back at our 50th edition titled Disrupt Kerala 2017, the speakers almost foretold what was imminent and have served as pointers for IT SMEs in India.</p>
          <p class="text-lg mt-2">As AI continues to shape and reshape the technological landscape, Evolve India 2023 will discuss four key points. Grab your Superpowers </p>
          <p class="text-lg mt-2"><strong> Grab your Superpowers</strong> Raising awareness about the AI-powered tools at our disposal. Discussing to turn them into competitive advantages.</p>
          <p class="text-lg mt-2"> <strong>Redesign your Talent Filters</strong> It is time to rethink the way we find and hire talent. </p>
          <p class="text-lg mt-2"><strong>Talent Hunting to Talent Farming </strong>Creating learning environments that foster the development of the right skills and talents. </p>
          <p class="text-lg mt-2"><strong>Company Strategy for AI</strong>  Exploring how Indian IT companies must approach the AI wave.</p>
          <div class="register-form mt-6 mx-auto  max-md:bottom-0 max-md:fixed  max-md:w-full max-md:left-0 z-10 md:mb-4 md:px-6 px-4 max-md:py-4" [ngClass]="currentTheme === 'dark' ? 'max-md:bg-gray-800' : 'max-md:bg-white'">
            <a href="https://www.youtube.com/watch?v=Un9m87gOeaI" target="_blank"
              class="btn btn-primary w-full text-white mb-2">Watch Now</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="w-full p-6 md:p-12" [ngClass]="currentTheme === 'dark' ? 'bg-[#232933]' : 'bg-slate-200'">
  <div class="container mx-auto">
    <h2 class="pb-4 flex"> <span class="font-bold  text-3xl pb-4 border-b" [ngClass]="currentTheme === 'dark' ? 'text-gray-300' : 'text-gray-600'">SPEAKERS </span></h2>
    <div class="grid  gap-4 md:gap-4 lg:gap-8 grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100" *ngFor="let speaker of speakerInfo" (click)="showModal(speaker)">
          <figure class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
            [src]="speaker?.thumbs" alt="{{ speaker.name }}" (error)="onProfilePicError($event)" />
          </figure>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">{{ speaker?.name}}</h2>
              <p class="text-neutral-400">{{speaker?.job_title}}</p>
            </div>
            <p>{{ speaker?.description.length > 100 ? (speaker?.description | slice: 0:100) + '...' :
              speaker?.description }}</p>
            <div class="card-actions justify-start">
              <span (click)="showModal(speaker);$event.stopPropagation();" class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>

<dialog class="modal" #speakerModal>
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button (click)="speakerModal.close()"
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left px-4 md:pr-8 pb-3 dk-image"><img class="w-full" [src]="selectedSpeaker?.thumbs" (error)="onProfilePicError($event)" /></div>
      <div>
        <h2 class="text-xl font-bold mb-0">{{ selectedSpeaker?.name }}</h2>
        <p class="text-neutral-400">{{ selectedSpeaker?.job_title }}</p>
        <p class="text-gray-500 text-sm leading-6 mt-4">{{selectedSpeaker?.description}}
        </p>
      </div>
    </div>
  </div>
</dialog>

